import { IContent, RentingSpacesTablesDataFragment } from '../content';

const RentingSpaces: IContent = {
	title: {
		sk: `Prenájom priestorov`,
		en: `Renting spaces`,
		de: `Vermietung von Räumen`
	},
	content: {
		sk: `Ponúkame na prenájom voľné kancelárske priestory na 1. poschodí OC Hypka. Všetky ceny sú uvedené bez DPH a za mesiac. V prípade záujmu o prehliadku alebo prenájom nás prosím kontaktujte na info@ochypka.sk.
		`,
		en: `We offer vacant office spaces for rent on the first floor of OC Hypka. All prices are monthly and exclude VAT. If you are interested in a viewing or renting a unit, please contact us at info@ochypka.sk.
		`,
		de: `Im 1. Obergeschoss des OC Hypka bieten wir freie Büroflächen zur Miete an. Alle Preise verstehen sich monatlich und ohne MwSt. Bei Interesse an einer Besichtigung oder Anmietung kontaktieren Sie uns bitte unter info@ochypka.sk.
		`
	},
	slug: {
		sk: 'prenajom-priestorov',
		en: 'renting-spaces',
		de: 'vermietung-von-raumen'
	}
};

export default RentingSpaces;

const firstFloor = {
	sk: '1. poschodie',
	en: '1st floor',
	de: '1. Obergeschoss'
};

const defaultPricing = {
	rentPerM2: 8,
	energyPerM2: 2.5,
	otherServicesPerM2: 1.5
};

export const RentingSpacesTableData: RentingSpacesTablesDataFragment[] = [
	{
		id: 'priestor-1',
		title: { sk: 'Priestor č. 1', en: 'Unit No. 1', de: 'Fläche Nr. 1' },
		images: ['/assets/renting_spaces/priestor-1.webp'],
		floor: firstFloor,
		area: 24.37,
		...defaultPricing
	},
	{
		id: 'priestor-2',
		title: { sk: 'Priestor č. 2', en: 'Unit No. 2', de: 'Fläche Nr. 2' },
		images: ['/assets/renting_spaces/priestor-2.webp'],
		floor: firstFloor,
		area: 27.86,
		...defaultPricing
	},
	{
		id: 'priestor-3',
		title: { sk: 'Priestor č. 3', en: 'Unit No. 3', de: 'Fläche Nr. 3' },
		images: ['/assets/renting_spaces/priestor-3.webp'],
		floor: firstFloor,
		area: 22.13,
		...defaultPricing
	}
];
